import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import type { Worktree } from "@rivets/core";
import { client } from "@/lib/api";
import { qk } from "@/lib/query-keys";
import { useArchiveToast } from "@/lib/archiveToastStore";

export function ArchiveToast() {
  const worktree = useArchiveToast((state) => state.worktree);
  const dismiss = useArchiveToast((state) => state.dismiss);
  const queryClient = useQueryClient();
  const [restoring, setRestoring] = useState(false);
  const [error, setError] = useState<string>();
  useEffect(() => {
    setRestoring(false);
    setError(undefined);
  }, [worktree?.id]);
  if (!worktree) return null;

  const restore = async () => {
    setRestoring(true);
    setError(undefined);
    try {
      const response = await client.restoreWorktree(worktree.id);
      queryClient.setQueryData<{ worktrees: Worktree[] }>(qk.worktrees(response.worktree.repoId), (old) => old
        ? { worktrees: old.worktrees.map((candidate) => candidate.id === response.worktree.id ? response.worktree : candidate) }
        : { worktrees: [response.worktree] });
      dismiss();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "This task could not be restored.");
    } finally {
      setRestoring(false);
    }
  };

  return (
    <div className="archive-toast" role="status" aria-live="polite">
      <span><strong>{worktree.name}</strong> archived. Local files will be removed in 7 days.{error ? <small>{error}</small> : null}</span>
      <button type="button" onClick={() => void restore()} disabled={restoring}>{restoring ? "Restoring…" : "Restore"}</button>
      <button type="button" className="archive-toast-close" onClick={dismiss} aria-label="Dismiss">×</button>
    </div>
  );
}
